"use client";
/**
 * Mutual-match celebration toast. Dismissable (unlike the §3 genetic block —
 * that one is structurally non-dismissable by design; this is just a toast).
 * Copy stays marketplace-framed: the next step is a conversation, not a
 * procedure — nothing medical happens on this platform.
 *
 * Label props keep this package free of i18n dependencies: the app passes
 * localized strings (see DiscoverDeck); defaults are the English copy.
 */
export function MatchToast({
  donorAlias,
  matchesHref,
  onDismiss,
  title = "It's a mutual match",
  body = "{alias} is interested too.",
  seeMatchesLabel = "See your matches",
  keepBrowsingLabel = "Keep browsing",
}: {
  donorAlias: string;
  matchesHref: string;
  onDismiss: () => void;
  title?: string;
  /** Body template; "{alias}" is replaced with the cleaned alias. */
  body?: string;
  seeMatchesLabel?: string;
  keepBrowsingLabel?: string;
}) {
  const alias = donorAlias.replace(/\s*\(SYNTHETIC\)\s*/, "");
  return (
    <div className="match-toast" role="status" aria-live="polite">
      <p className="match-toast-title">{title}</p>
      <p className="match-toast-body">{body.replace("{alias}", alias)}</p>
      <div className="match-toast-actions">
        <a href={matchesHref} className="match-toast-link">
          {seeMatchesLabel}
        </a>
        <button type="button" onClick={onDismiss} className="match-toast-dismiss">
          {keepBrowsingLabel}
        </button>
      </div>
    </div>
  );
}
